
export default {
  'terms.title': 'Términos y Condiciones',
  'terms.subtitle': 'Lea atentamente los siguientes términos y condiciones antes de usar nuestros servicios.',
  'terms.last_updated': 'Última actualización:',
  'terms.introduction.title': 'Introducción',
  'terms.introduction.content': 'Bienvenido a Pink Paradise. Al acceder a nuestro sitio web y utilizar nuestros servicios, usted acepta cumplir con estos términos y condiciones. Le recomendamos que los lea detenidamente.',
  
  'privacy.title': 'Política de Privacidad',
  'privacy.subtitle': 'Cómo recopilamos, usamos y protegemos su información personal.',
  'privacy.last_updated': 'Última actualización:',
  'privacy.introduction.title': 'Nuestra Política de Privacidad',
  'privacy.introduction.content': 'En Pink Paradise, valoramos y respetamos su privacidad. Esta política describe qué información recopilamos, cómo la usamos y sus derechos con respecto a sus datos.',
  
  'cookies.title': 'Política de Cookies',
  'cookies.subtitle': 'Información sobre las cookies que utilizamos en nuestro sitio web.',
  'cookies.last_updated': 'Última actualización:',
  'cookies.introduction.title': 'Uso de Cookies',
  'cookies.introduction.content': 'Nuestro sitio web utiliza cookies para mejorar su experiencia. Esta política explica qué son las cookies, cómo las usamos y cómo puede gestionarlas.',
  
  'content_policy.title': 'Política de Contenido',
  'content_policy.subtitle': 'Estándares para el contenido permitido en nuestra plataforma.',
  'content_policy.last_updated': 'Última actualización:',
  'content_policy.introduction.title': 'Nuestra Política de Contenido',
  'content_policy.introduction.content': 'Pink Paradise se compromete a mantener un entorno seguro y respetuoso. Esta política establece los estándares de contenido que todos los usuarios deben seguir.',
  
  'about.title': 'Acerca de Nosotros',
  'about.subtitle': 'Conozca más sobre Pink Paradise.',
  'about.mission_title': 'Nuestra Misión',
  'about.mission_content': 'En Pink Paradise, estamos comprometidos a crear un entorno seguro, discreto y premium donde los adultos pueden conectarse para relaciones mutuamente beneficiosas.',
  'about.why_choose': 'Por Qué Elegir Pink Paradise',
  'about.safety_first': 'Seguridad Primero',
  'about.quality_selection': 'Selección de Calidad',
  'about.discreet_service': 'Servicio Discreto',
  'about.support': 'Soporte 24/7',
  
  'how_it_works.title': 'Cómo Funciona',
  'how_it_works.subtitle': 'Una plataforma segura y discreta que conecta clientes con escorts verificados para experiencias auténticas.',
  'how_it_works.for_clients': 'Para Clientes',
  'how_it_works.for_escorts': 'Para Escorts',
  'how_it_works.secure_private': 'Seguro y Privado',
  'how_it_works.verified_profiles': 'Perfiles Verificados',
  'how_it_works.secure_payments': 'Pagos Seguros',
  
  'blog.title': 'Blog',
  'blog.subtitle': 'Perspectivas, consejos e historias de nuestra comunidad y expertos para ayudarte a navegar el mundo de las conexiones en línea.',
  'blog.read_article': 'Leer Artículo',
  'blog.load_more': 'Cargar Más Artículos',
  
  'faq.title': 'Preguntas Frecuentes',
  'faq.subtitle': 'Encuentra respuestas a las preguntas más comunes sobre nuestra plataforma y servicios.',
  'faq.search_placeholder': 'Buscar respuestas...',
  'faq.search_button': 'Buscar',
  'faq.still_questions': '¿Todavía tienes preguntas?',
  'faq.contact_support': 'No puedes encontrar la respuesta que buscas? Por favor contacta a nuestro amable equipo de soporte.',
  'faq.contact_button': 'Contactar Soporte',
  
  'safety_tips.title': 'Consejos de Seguridad',
  'safety_tips.subtitle': 'Protégete mientras usas nuestra plataforma con estos consejos esenciales de seguridad.',
  
  'security.title': 'Seguridad',
  'security.subtitle': 'Cómo protegemos tu información y mantenemos tu seguridad en nuestra plataforma.',
  
  'support.title': 'Soporte',
  'support.subtitle': 'Estamos aquí para ayudarte. Contacta con nuestro equipo de soporte para cualquier consulta o asistencia.',
  'support.contact_us': 'Contáctanos',
  'support.form.name': 'Tu Nombre',
  'support.form.email': 'Tu Email',
  'support.form.subject': 'Asunto',
  'support.form.message': 'Mensaje',
  'support.form.submit': 'Enviar Mensaje'
};
